import React, { useEffect, useRef, useContext, useState, forwardRef } from "react";
import "./widgetcss/styles.css";
import { MapContext } from "../MapContext";


// informacine kortele rodoma po prisijungimo arba paspaudus "i" mygtuka heatmap'e
// paquerinamas vienas servias ir jo duomenys sudedami i kortele
export default function Error () {

    const mapContext = useContext(MapContext);
    const [showCard, setShowCard] = useState(false);
    

    const infoCardRef = useRef(null);

    const handleClickOutside = (event) => {
        if (infoCardRef.current && !infoCardRef.current.contains(event.target)) {
            mapContext.dispatch({
                error: "none",
            });
            setShowCard(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {  
        if (mapContext.state.error !== "none") {
            setShowCard(true);        
            mapContext.dispatch({
                    clearFlag: 1,
            })
        }   
        
    }, [mapContext.state.error]);


    return (
        <>
        {
            showCard === false ? <> </> :
          <div id = "ErrorCard"  ref={infoCardRef}>
            <div id = "InfoCardClose" onClick={() => {
                setShowCard(false)
                mapContext.dispatch({
                    error: "none",
                })
                
            }}>X</div>
            <div id = "ErrorCardTtile">! <br/> Klaida</div>
            <br/>
            {mapContext.state.error}
          </div>

        } 
        </>
    )
}